import { apiClient } from "../api/client";
import { API_URLS } from "../api/config";
const { RssFeed } = API_URLS;

export const listRssFeed = (payload) => {
  return apiClient({ url: RssFeed.list, data: payload })
    .then((res) => res?.data===null?{}:res?.data===null?{}:res?.data===null?{}:res?.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const createRssFeed = (payload) => {
  return apiClient({ url: RssFeed.create, data: payload })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err?.data?.message);
    });
};

export const updateRssFeed = (payload) => {
  return apiClient({
    url: RssFeed.update + payload.id,
    data: payload,
    method: "PUT",
  })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err?.data?.message || "Can't update record.");
    });
};

export const softDeleteRssFeed = (payload) => {
  return apiClient({
    url: RssFeed.softdelete + payload.id,
    data: payload,
    method: "PUT",
  })
    .then((res) => console.log(res))
    .catch((err) => {
      throw new Error(err);
    });
};

export const deleteRssFeed = (payload) => {
  return apiClient({
    url: RssFeed.delete + payload.id,
    data: payload,
    method: "DELETE",
  })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getRssFeedCount = () => {
  return apiClient({ url: RssFeed.count })
    .then((res) => res.data?.totalRecords || 0)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getRssFeedAggregate = (payload) => {
  return apiClient({ url: RssFeed.aggregation, data: payload })
    .then((res) => res.data?.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getRssFeedById = (payload) => {  
  return apiClient({
    url: RssFeed.singlerecord + payload,
    data: { query: { isActive: true, isDeleted: false } },
    method: "GET",
  })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const softDeleteMultipleRssFeed = (payload) => {
  return apiClient({
    url: RssFeed.multisoftdelete,
    data: payload,
    method: "PUT",
  })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
};
export const suspendRssFeed = (payload) => {
  console.log("payload.id",payload.id)
  return apiClient({
    url: RssFeed.suspend_unSuspend,
    data: {userId:payload.id},
    method: "PUT",
  })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err?.data?.message || "Can't suspend/unsuspend record.");
    });
};
